var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible1,
            "close-on-click-modal": false,
            title: "编辑导航位",
            width: "900px",
            "custom-class": "dialog_box",
          },
          on: { close: _vm.onClose },
        },
        [
          _c(
            "div",
            { staticClass: "from_box" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "导航名称:", prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: _vm.boole },
                        model: {
                          value: _vm.ruleForm.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "title", $$v)
                          },
                          expression: "ruleForm.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "未选中状态图:", prop: "normalUrl" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "80px",
                            height: "80px",
                            background: "#f9f9f9",
                            "border-radius": "4px",
                            border: "1px solid #eeeeee",
                            position: "relative",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                "show-file-list": false,
                                action: "",
                                "http-request": function (value) {
                                  return _vm.handleFileUpload(
                                    value,
                                    "normalUrl"
                                  )
                                },
                              },
                            },
                            [
                              _vm.ruleForm.normalUrl &&
                              _vm.ruleForm.normalUrl != null
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "80px",
                                      height: "80px",
                                    },
                                    attrs: {
                                      src: _vm.ruleForm.normalUrl,
                                      fit: "contain",
                                    },
                                  })
                                : _c("i", {
                                    staticClass:
                                      "el-icon-plus avatar-uploader-icon",
                                  }),
                              _vm._v(" "),
                              _vm.ruleForm.normalUrl
                                ? _c("i", {
                                    staticClass: "el-icon-error",
                                    staticStyle: {
                                      position: "absolute",
                                      right: "-30px",
                                      top: "-10px",
                                      "font-size": "25px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.delPic("normalUrl")
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#969696",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("图片尺寸50*50，png格式")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "选中状态图:", prop: "selectUrl" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "80px",
                            height: "80px",
                            background: "#f9f9f9",
                            "border-radius": "4px",
                            border: "1px solid #eeeeee",
                            position: "relative",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                "show-file-list": false,
                                action: "",
                                "http-request": function (value) {
                                  return _vm.handleFileUpload(
                                    value,
                                    "selectUrl"
                                  )
                                },
                              },
                            },
                            [
                              _vm.ruleForm.selectUrl &&
                              _vm.ruleForm.selectUrl != null
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "80px",
                                      height: "80px",
                                    },
                                    attrs: {
                                      src: _vm.ruleForm.selectUrl,
                                      fit: "contain",
                                    },
                                  })
                                : _c("i", {
                                    staticClass:
                                      "el-icon-plus avatar-uploader-icon",
                                  }),
                              _vm._v(" "),
                              _vm.ruleForm.selectUrl
                                ? _c("i", {
                                    staticClass: "el-icon-error",
                                    staticStyle: {
                                      position: "absolute",
                                      right: "-30px",
                                      top: "-10px",
                                      "font-size": "25px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.delPic("selectUrl")
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#969696",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("图片尺寸50*50，png格式")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.boole
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "活动跳转:", prop: "jumpType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.ruleForm.jumpType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "jumpType", $$v)
                                },
                                expression: "ruleForm.jumpType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("选择活动"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("url跳转"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.jumpType === 2
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "活动选择:" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.goAct()
                                },
                              },
                            },
                            [_vm._v("去选择")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.jumpType === 2
                    ? _c("el-form-item", { attrs: { label: "" } }, [
                        _vm.ruleForm.activityName &&
                        _vm.ruleForm.activityTypeName
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "background-color": "#f8f8f8",
                                  padding: "10px",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "flex-start",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { width: "80px" } },
                                      [_vm._v("活动类型:")]
                                    ),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { readonly: true },
                                      model: {
                                        value: _vm.ruleForm.activityTypeName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "activityTypeName",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.activityTypeName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "flex-start",
                                      "align-items": "center",
                                      margin: "5px 0",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { width: "80px" } },
                                      [_vm._v("活动名称:")]
                                    ),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { readonly: true },
                                      model: {
                                        value: _vm.ruleForm.activityName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "activityName",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.activityName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.jumpType === 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "跳转链接:", prop: "openUrl" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入跳转链接" },
                            model: {
                              value: _vm.ruleForm.openUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "openUrl", $$v)
                              },
                              expression: "ruleForm.openUrl",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.boole
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "是否展示:", prop: "isShow" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.ruleForm.isShow,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "isShow", $$v)
                                },
                                expression: "ruleForm.isShow",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("展示"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不展示"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.resetForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("ActivitySelectionPopup", {
        ref: "activitySelectionPopup",
        on: { SelectEvents: _vm.onSelectEvents },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }